// Generato da apps/core-api/scripts/istruzioni-consulente.ts dal titolo del contratto n. 1: non modificare a mano.
export const CONTRATTO_1_VERSIONE = '2.26';
